<script setup lang="ts">
import { useGlobals } from '@/helpers/globals';

const globals = useGlobals();
</script>
<template>
    <ktg-footer>
        <ktg-footer-column slot="columns-left" :content-title="$t('eplan_portal')">
            {{ globals.show_under_development_info ? $t('eplan_coming_soon_info') : $t('eplan_portal_info') }}
            <div class="mt-1rem">Version {{ globals.app_version }}</div>
        </ktg-footer-column>
        <ktg-footer-column slot="columns-right" content-title="Departement für Bau und Umwelt">
            <address>
                Verwaltungsgebäude<br />
                Promenadenstrasse 8<br />
                8510 Frauenfeld
            </address>
            <p class="mt-1rem">
                <ktg-link href="mailto:planungen.dbu@tg.ch" target="_blank">planungen.dbu@tg.ch</ktg-link>
            </p>
        </ktg-footer-column>
        <ktg-footer-column slot="columns-right" content-title="Verband Thurgauer Gemeinden">
            <address>
                Thomas-Bornhauser-<br />
                Strasse 23a<br />
                8570 Weinfelden
            </address>
            <p class="mt-1rem">
                <ktg-link href="https://vtg.ch" target="_blank" trailing-icon="open-new-tab">Webseite</ktg-link>
            </p>
        </ktg-footer-column>
        <!-- Navigation -->
        <ktg-footer-navigation>
            <ktg-footer-navigation-item href="https://schalter.tg.ch/Rechtliches.html">
                {{ $t('rechtliches') }}
            </ktg-footer-navigation-item>
            <ktg-footer-navigation-item href="https://schalter.tg.ch/Datenschutz.html">
                {{ $t('datenschutz') }}
            </ktg-footer-navigation-item>
            <ktg-footer-navigation-item href="https://schalter.tg.ch/Barrierefreiheit.html">
                {{ $t('barrierefreiheit') }}
            </ktg-footer-navigation-item>
        </ktg-footer-navigation>
    </ktg-footer>
</template>

<style scoped lang="scss">
address {
    font-style: normal;
}
</style>
